import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PositionSearchComponent } from './component/position-search.component';
import { HvlNgSharedModule, PrimengSharedModule } from '@hvlng/framework-core/shared';
import { UiSharedModule } from 'ui-shared';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [PositionSearchComponent],
    imports: [CommonModule, PrimengSharedModule, HvlNgSharedModule, UiSharedModule, TranslateModule],
    exports: [PositionSearchComponent],
})
export class PositionSearchModule {}
